(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["glossary"] && !Shopify.designMode) return;
  try {
    
  class GlossarySection {
    static PANEL_VT = 'glossary-panel';
    static LIST_VT = 'glossary-term-list';

    /** Firefox mis-positions list view-transition groups (fly / jump to 0,0). */
    static useListViewTransition() {
      return !/Firefox\//i.test(navigator.userAgent);
    }

    constructor(el) {
      this.el = el;
      this.currentHandle = null;
      this.currentGroup = null;
      this.termList = el.querySelector('.glossary__term-list');
      this.tabs = [...el.querySelectorAll('.glossary__tab')];
      this.termItems = [...el.querySelectorAll('.glossary__term-item')];
      this.termButtons = [...el.querySelectorAll('.glossary__term-button')];
      this.panels = [...el.querySelectorAll('.glossary__panel')];

      // Global alphabetical order of every term, matching DOM order.
      this.order = this.termItems.map((item) => item.dataset.handle);
      this.prevBtn = el.querySelector('[data-prev]');
      this.nextBtn = el.querySelector('[data-next]');
      this.counter = el.querySelector('[data-counter]');

      this.tabs.forEach((tab) => {
        tab.addEventListener('click', () => this.activateGroup(tab.dataset.group));
      });

      this.termButtons.forEach((btn) => {
        btn.addEventListener('click', () => this.activateTerm(btn.dataset.handle));
      });

      this.prevBtn?.addEventListener('click', () => this.step(-1));
      this.nextBtn?.addEventListener('click', () => this.step(1));

      // Left / right arrows step through terms when the section holds focus.
      el.addEventListener('keydown', (event) => {
        if (event.key === 'ArrowRight') {
          event.preventDefault();
          this.step(1);
        } else if (event.key === 'ArrowLeft') {
          event.preventDefault();
          this.step(-1);
        }
      });

      const defaultHandle = el.dataset.defaultTerm;
      const defaultItem = defaultHandle && this.termItems.find((i) => i.dataset.handle === defaultHandle);
      const startGroup = defaultItem
        ? defaultItem.dataset.group
        : this.tabs[0]?.dataset.group;

      if (startGroup) {
        this.activateGroup(startGroup, defaultHandle || null, { animate: false });
      }
    }

    canAnimateViewTransition() {
      return (
        typeof document.startViewTransition === 'function' &&
        !window.matchMedia('(prefers-reduced-motion: reduce)').matches
      );
    }

    clearTransitionNames() {
      if (this.termList) {
        this.termList.style.viewTransitionName = '';
      }
      this.panels.forEach((panel) => {
        panel.style.viewTransitionName = '';
      });
    }

    getGroupHandle(group, preferHandle) {
      const visibleItems = this.termItems.filter((item) => item.dataset.group === group);
      const preferred = preferHandle &&
        visibleItems.find((item) => item.dataset.handle === preferHandle);

      return preferred ? preferHandle : visibleItems[0]?.dataset.handle ?? null;
    }

    setGroupTermVisibility(group) {
      this.termItems.forEach((item) => {
        item.hidden = item.dataset.group !== group;
      });
    }

    applyTerm(handle, { markIncoming = false } = {}) {
      this.termItems.forEach((item) => {
        item.classList.toggle('is-active', item.dataset.handle === handle);
      });
      this.panels.forEach((panel) => {
        const show = panel.dataset.handle === handle;
        panel.hidden = !show;
        if (show && markIncoming) {
          panel.style.viewTransitionName = GlossarySection.PANEL_VT;
        }
      });
      this.currentHandle = handle;
      this.updateNav();
    }

    updateNav() {
      const idx = this.order.indexOf(this.currentHandle);
      if (this.counter) {
        this.counter.textContent = `${idx + 1} / ${this.order.length}`;
      }
      if (this.prevBtn) {
        this.prevBtn.disabled = idx <= 0;
      }
      if (this.nextBtn) {
        this.nextBtn.disabled = idx < 0 || idx >= this.order.length - 1;
      }
    }

    /** Step to the neighbouring term in global order, crossing tab groups. */
    step(direction) {
      const idx = this.order.indexOf(this.currentHandle);
      const nextIdx = idx + direction;
      if (idx < 0 || nextIdx < 0 || nextIdx >= this.order.length) {
        return;
      }

      const handle = this.order[nextIdx];
      this.goToHandle(handle);

      const item = this.termItems.find((i) => i.dataset.handle === handle);
      if (item) {
        requestAnimationFrame(() => item.scrollIntoView({ block: 'nearest' }));
      }
    }

    /** Activate a term by handle, switching the tab group first if needed. */
    goToHandle(handle) {
      const item = this.termItems.find((i) => i.dataset.handle === handle);
      if (!item) {
        return;
      }
      if (item.dataset.group !== this.currentGroup) {
        this.activateGroup(item.dataset.group, handle);
      } else {
        this.activateTerm(handle);
      }
    }

    setListViewTransitionName(active) {
      if (!this.termList) {
        return;
      }
      this.termList.style.viewTransitionName =
        active && GlossarySection.useListViewTransition() ? GlossarySection.LIST_VT : '';
    }

    fadeTermListOpacity(opacity) {
      const list = this.termList;
      if (!list) {
        return Promise.resolve();
      }

      return new Promise((resolve) => {
        const durationMs = 400;
        const fallback = window.setTimeout(resolve, durationMs);

        const onEnd = (event) => {
          if (event.target !== list || event.propertyName !== 'opacity') {
            return;
          }
          window.clearTimeout(fallback);
          list.removeEventListener('transitionend', onEnd);
          if (opacity === 1) {
            list.style.opacity = '';
          }
          resolve();
        };

        list.addEventListener('transitionend', onEnd);

        if (opacity === 0) {
          list.style.opacity = '0';
          return;
        }

        requestAnimationFrame(() => {
          requestAnimationFrame(() => {
            list.style.opacity = '1';
          });
        });
      });
    }

    markOutgoingContent() {
      this.setListViewTransitionName(true);
      const outgoingPanel = this.panels.find((panel) => !panel.hidden);
      if (outgoingPanel) {
        outgoingPanel.style.viewTransitionName = GlossarySection.PANEL_VT;
      }
    }

    activateGroup(group, preferHandle, { animate = true } = {}) {
      const groupChanged = this.currentGroup !== null && group !== this.currentGroup;
      const handle = this.getGroupHandle(group, preferHandle);

      const update = () => {
        this.tabs.forEach((tab) => {
          const active = tab.dataset.group === group;
          tab.classList.toggle('is-active', active);
          tab.setAttribute('aria-pressed', String(active));
        });
        this.setGroupTermVisibility(group);
        this.currentGroup = group;
        this.setListViewTransitionName(true);
        if (handle) {
          this.applyTerm(handle, { markIncoming: true });
        }
      };

      const shouldAnimate =
        animate &&
        groupChanged &&
        this.canAnimateViewTransition();

      if (!shouldAnimate) {
        this.tabs.forEach((tab) => {
          const active = tab.dataset.group === group;
          tab.classList.toggle('is-active', active);
          tab.setAttribute('aria-pressed', String(active));
        });
        this.setGroupTermVisibility(group);
        this.currentGroup = group;
        if (handle) {
          this.applyTerm(handle);
        }
        this.clearTransitionNames();
        return;
      }

      if (!GlossarySection.useListViewTransition()) {
        this.fadeTermListOpacity(0).then(() => {
          this.markOutgoingContent();
          const transition = document.startViewTransition(update);
          transition.finished
            .finally(() => this.clearTransitionNames())
            .then(() => this.fadeTermListOpacity(1));
        });
        return;
      }

      this.markOutgoingContent();
      const transition = document.startViewTransition(update);
      transition.finished.finally(() => this.clearTransitionNames());
    }

    activateTerm(handle, { animate = true } = {}) {
      const termChanged = handle !== this.currentHandle;

      const update = () => {
        this.applyTerm(handle, { markIncoming: true });
      };

      if (!animate || !termChanged || !this.canAnimateViewTransition()) {
        this.applyTerm(handle);
        this.clearTransitionNames();
        return;
      }

      const outgoingPanel = this.panels.find((panel) => !panel.hidden);
      if (outgoingPanel) {
        outgoingPanel.style.viewTransitionName = GlossarySection.PANEL_VT;
      }

      const transition = document.startViewTransition(update);
      transition.finished.finally(() => this.clearTransitionNames());
    }
  }

  document.querySelectorAll('.glossary').forEach((el) => new GlossarySection(el));

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"] && !Shopify.designMode) return;
  try {
    
  (function () {
    var header = document.querySelector('[data-header]');
    var mode = header ? header.getAttribute('data-sticky') : 'none';
    var lastY = window.scrollY;

    function onScroll() {
      var y = window.scrollY;

      // Compact the header once scrolled (theme reads body.is-scrolled to swap
      // --header-offset to the compact height).
      document.body.classList.toggle('is-scrolled', y > 8);

      // "On scroll up": hide when scrolling down past the header, reveal on
      // scroll up (and always show near the top).
      if (mode === 'scroll-up' && header) {
        if (y > lastY && y > 80) {
          header.classList.add('header--hidden');
        } else {
          header.classList.remove('header--hidden');
        }
      }

      lastY = y;
    }

    onScroll();
    window.addEventListener('scroll', onScroll, { passive: true });

    // Close the mobile nav drawer when a link inside it is followed.
    document.addEventListener('click', function (event) {
      var link = event.target.closest('.header-menu a');
      if (!link) return;
      var drawer = document.querySelector('.header__nav-drawer[open]');
      if (drawer) drawer.removeAttribute('open');
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-cart"]) return;
  try {
    
  (function () {
    document.documentElement.classList.add('js-cart');

    function root() { return document.querySelector('[data-cart-root]'); }

    function change(key, quantity) {
      const el = root();
      if (!el) return;
      const url = el.getAttribute('data-cart-change-url') + '.js';
      const sectionId = el.getAttribute('data-section-id');
      el.setAttribute('aria-busy', 'true');

      fetch(url, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify({
          id: key,
          quantity: quantity,
          sections: sectionId,
          sections_url: window.location.pathname,
        }),
      })
        .then((r) => r.json())
        .then((state) => {
          if (state && state.sections && state.sections[sectionId]) {
            const doc = new DOMParser().parseFromString(state.sections[sectionId], 'text/html');
            const fresh = doc.querySelector('[data-cart-root]');
            const current = root();
            if (fresh && current) current.replaceWith(fresh);
          }
          document.dispatchEvent(new CustomEvent('cart:updated', { bubbles: true, detail: { cart: state } }));
        })
        .catch(() => {
          const el2 = root();
          if (el2) el2.removeAttribute('aria-busy');
        });
    }

    // Typed quantity change
    document.addEventListener('change', (event) => {
      const input = event.target.closest('[data-qty-input]');
      if (!input) return;
      let q = parseInt(input.value, 10);
      if (isNaN(q) || q < 0) q = 0;
      change(input.getAttribute('data-key'), q);
    });

    // Stepper + remove (delegated: survives section re-render + editor injection)
    document.addEventListener('click', (event) => {
      const dec = event.target.closest('[data-qty-decrease]');
      const inc = event.target.closest('[data-qty-increase]');
      const remove = event.target.closest('[data-cart-remove]');

      if (dec || inc) {
        const wrap = (dec || inc).closest('[data-qty]');
        const input = wrap && wrap.querySelector('[data-qty-input]');
        if (!input) return;
        let q = parseInt(input.value, 10) || 0;
        q = inc ? q + 1 : Math.max(0, q - 1);
        input.value = q;
        change(input.getAttribute('data-key'), q);
      } else if (remove) {
        event.preventDefault();
        const item = remove.closest('[data-cart-item]');
        const key = item && item.getAttribute('data-key');
        if (key) change(key, 0);
      }
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["science-features"] && !Shopify.designMode) return;
  try {
    
  function registerScienceFeatures() {
    const Base = window.TomeCarouselElement;
    if (!Base || customElements.get('science-features')) {
      return Boolean(customElements.get('science-features'));
    }

    class ScienceFeatures extends Base {
      constructor() {
        super();
        this.track = null;
        this.blockCount = 1;
        this.scrollSync = false;
        this.rafId = 0;
        this.onScroll = this.onScroll.bind(this);
        this.onMediaChange = this.onMediaChange.bind(this);
        this.onResize = this.onResize.bind(this);
        this.desktopMediaQuery = window.matchMedia('(min-width: 769px)');
      }

      getHeaderOffset() {
        const raw = getComputedStyle(document.documentElement)
          .getPropertyValue('--header-offset')
          .trim();
        const parsed = parseFloat(raw);
        return Number.isNaN(parsed) ? 0 : parsed;
      }

      getScrollTriggerY() {
        return this.getHeaderOffset() + window.innerHeight * 0.66;
      }

      readBlockCount() {
        const fromTrack = parseInt(this.track?.dataset.blockCount || '', 10);
        if (!Number.isNaN(fromTrack) && fromTrack > 0) {
          return fromTrack;
        }
        return this.slideCount;
      }

      connectedCallback() {
        super.connectedCallback();
        this.track = this.parentElement?.classList.contains('science-features__track')
          ? this.parentElement
          : this.closest('.science-features__track');
        this.blockCount = this.readBlockCount();
        this.desktopMediaQuery.addEventListener('change', this.onMediaChange);
        window.addEventListener('resize', this.onResize, { passive: true });
        this.onMediaChange();
      }

      disconnectedCallback() {
        super.disconnectedCallback();
        this.teardownScroll();
        this.desktopMediaQuery.removeEventListener('change', this.onMediaChange);
        window.removeEventListener('resize', this.onResize);
        if (this.rafId) {
          cancelAnimationFrame(this.rafId);
          this.rafId = 0;
        }
      }

      teardownScroll() {
        window.removeEventListener('scroll', this.onScroll);
      }

      setupScroll() {
        this.teardownScroll();
        if (!this.desktopMediaQuery.matches || this.blockCount < 2) {
          return;
        }

        window.addEventListener('scroll', this.onScroll, { passive: true });
        this.onScroll();
      }

      onMediaChange() {
        this.blockCount = this.readBlockCount();
        if (this.desktopMediaQuery.matches && this.blockCount > 1) {
          this.setupScroll();
          return;
        }
        this.teardownScroll();
        this.updateProgressMetersForIndex(this.currentIndex);
      }

      onResize() {
        this.onScroll();
      }

      onScroll() {
        if (this.rafId) {
          return;
        }
        this.rafId = requestAnimationFrame(() => {
          this.rafId = 0;
          this.updateActiveFromScroll();
        });
      }

      getItemProgress(item, triggerY) {
        const rect = item.getBoundingClientRect();
        if (rect.height <= 0) {
          return 0;
        }

        if (rect.bottom <= triggerY) {
          return 1;
        }

        if (rect.top >= triggerY) {
          return 0;
        }

        return (triggerY - rect.top) / rect.height;
      }

      updateProgressMetersFromItems(triggerY) {
        this.items.forEach((item) => {
          const fill = item.querySelector('[data-progress-fill]');
          if (!fill) {
            return;
          }

          const amount = this.getItemProgress(item, triggerY);
          fill.style.width = `${Math.min(1, Math.max(0, amount)) * 100}%`;
        });
      }

      updateProgressMetersForIndex(index) {
        this.items.forEach((item) => {
          const fill = item.querySelector('[data-progress-fill]');
          if (!fill) {
            return;
          }

          const itemIndex = parseInt(item.dataset.index, 10);
          if (Number.isNaN(itemIndex)) {
            return;
          }

          const amount = itemIndex < index ? 1 : itemIndex === index ? 1 : 0;
          fill.style.width = `${amount * 100}%`;
        });
      }

      getActiveIndexFromScroll(triggerY) {
        let activeIndex = 0;
        let closestDistance = Infinity;

        this.items.forEach((item) => {
          const itemIndex = parseInt(item.dataset.index, 10);
          if (Number.isNaN(itemIndex)) {
            return;
          }

          const rect = item.getBoundingClientRect();
          const itemCenter = rect.top + rect.height / 2;
          const distance = Math.abs(itemCenter - triggerY);

          if (distance < closestDistance) {
            closestDistance = distance;
            activeIndex = itemIndex;
          }
        });

        return activeIndex;
      }

      updateActiveFromScroll() {
        if (this.blockCount < 2) {
          return;
        }

        const triggerY = this.getScrollTriggerY();
        const index = this.getActiveIndexFromScroll(triggerY);

        this.updateProgressMetersFromItems(triggerY);
        this.scrollSync = true;
        this.goTo(index);
        this.scrollSync = false;
      }

      scrollItemIntoView(index) {
        const item = this.items[index];
        if (!item) {
          return;
        }

        const prefersReducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
        item.scrollIntoView({
          behavior: prefersReducedMotion ? 'auto' : 'smooth',
          block: 'center',
        });
      }

      goTo(index) {
        const previousIndex = this.currentIndex;
        const fromScroll = this.scrollSync;
        super.goTo(index);

        if (!fromScroll && !this.desktopMediaQuery.matches) {
          this.updateProgressMetersForIndex(index);
        }

        if (fromScroll || !this.desktopMediaQuery.matches || index === previousIndex) {
          return;
        }

        this.scrollItemIntoView(index);
      }
    }

    customElements.define('science-features', ScienceFeatures);
    return true;
  }

  if (!registerScienceFeatures()) {
    document.addEventListener('DOMContentLoaded', registerScienceFeatures);
    window.addEventListener('load', registerScienceFeatures);
  }

  document.addEventListener('shopify:section:load', () => {
    registerScienceFeatures();
    document.querySelectorAll('science-features').forEach((el) => {
      if (typeof el.updateActiveFromScroll === 'function') {
        el.updateActiveFromScroll();
      }
    });
  });

  } catch(e) { console.error(e); }
})();
})();
